import { DocumentInput } from '../gql/graphql';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const DOWNLOAD_FILES_QUERY = graphql(`
  query downloadFile($input: DocumentInput!) {
    file: downloadFiles(documentInput: $input) {
      file
      fileUrl
      folderUrl
      result
    }
  }
`);

export function useDownloadFile(input: DocumentInput) {
  const { loading, error, data } = useQuery(DOWNLOAD_FILES_QUERY, {
    variables: {
      input,
    },
    fetchPolicy: 'no-cache',
  });

  const file = useMemo(() => {
    return data?.file;
  }, [data]);

  return {
    loading,
    error,
    data,
    file,
  };
}
